import React from 'react';
import { Card, Typography, List, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const AlertsTitle = styled(Typography)({
  '&.MuiTypography-root': {
    color: '#fb7185 !important', // Rose/red with higher specificity
  }
});

const DeadlinesTitle = styled(Typography)({
  '&.MuiTypography-root': {
    color: '#f59e0b !important', // Amber/orange with higher specificity
  }
});

interface ComplianceStatusProps {
  alerts: number;
  upcomingDeadlines: Array<{
    id: string;
    date: Date;
    description: string;
    type: string;
  }>;
}

export const ComplianceStatus: React.FC<ComplianceStatusProps> = ({
  alerts,
  upcomingDeadlines
}) => {
  return (
    <div className="compliance-status">
      <div className="alerts-section">
        <AlertsTitle variant="h6">Active Alerts</AlertsTitle>
        <Typography variant="h3" color={alerts > 0 ? "error" : "success"}>
          {alerts}
        </Typography>
      </div>
      <div className="deadlines-section">
        <DeadlinesTitle variant="h6">Upcoming Deadlines</DeadlinesTitle>
        <List>
          {upcomingDeadlines.map(deadline => (
            <ListItem key={deadline.id}>
              <Typography variant="body2">
                {new Date(deadline.date).toLocaleDateString()}: {deadline.description}
              </Typography>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
}; 